module.exports = __webpack_public_path__ + "static/media/loading.5667e166.svg";